import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LayerButton, ButtonText, SettingsIcon } from "../styled";
import { DateFilterContext } from "../context";

export default () => {
  const { t } = useTranslation("dateFilter");
  const { setSettingVisibility } = useContext(DateFilterContext);

  return (
    <LayerButton
      onClick={() => {
        setSettingVisibility(true);
      }}
    >
      <SettingsIcon kind="settings" />
      <ButtonText>{t("selectLayer")}</ButtonText>
    </LayerButton>
  );
};
